import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { AnalyticOrgGeneral } from '../../../../view/analytics/org/analytic-org-general'
import { AnalyticOrgCustom } from '../../../../view/analytics/org/analytic-org-custom'
import { LmsInsights } from '../../../../view/analytics/lms/lms-insights'
import { LMS_INSIGHT_BASE, LMS_INSIGHT_TABS } from '../../../../view/analytics/lms/lms-insight-tabs'

// The addresses the LMS insights page draws at: the section (which it sends to
// the first tab) and each tab, so a new tab needs no route of its own.
const LMS_INSIGHT_PATHS = [LMS_INSIGHT_BASE, ...LMS_INSIGHT_TABS.map(tab => tab.to)]

export const LayoutAnalytic = () => {
  return (
    <React.Fragment>
      <Route path="/org/analytic/general" component={AnalyticOrgGeneral} />
      <Route path="/org/analytic/custom" component={AnalyticOrgCustom} />
      {/* LMS insights: the gate (system administrators and root while the
          staff-only switch is closed) and the tabs are the page's own.

          The page's BreadcrumbView draws its body only when the route that
          mounted it matches the address EXACTLY, so the page is mounted by an
          exact route: the section or one tab. Any other address under the
          section (an unknown tab, an address below a tab) matches the second
          route, which is not exact and so draws only the page's own
          not-found. */}
      <Switch>
        <Route exact path={LMS_INSIGHT_PATHS} component={LmsInsights} />
        <Route path={LMS_INSIGHT_BASE} component={LmsInsights} />
      </Switch>
    </React.Fragment>
  )
}
